import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-crystal-charcoal via-crystal-charcoal/95 to-crystal-charcoal">
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="mb-8">
          <Button variant="ghost" className="text-white/80 hover:text-white hover:bg-white/10 mb-6" asChild>
            <Link to="/">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Home
            </Link>
          </Button>
          <h1 className="text-4xl font-bold text-white mb-4">Cookie Policy</h1>
          <p className="text-white/60">Last updated: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="glass-panel p-8 space-y-8">
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">What Are Cookies</h2>
            <p className="text-white/80 leading-relaxed">
              Cookies are small text files that are stored on your device when you visit our website. 
              They help us provide you with a better experience by remembering your preferences and 
              ensuring our platform functions properly.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Types of Cookies We Use</h2>
            
            <div className="space-y-6">
              <div className="border border-white/10 rounded-lg p-4">
                <h3 className="text-lg font-medium text-white mb-2">Essential Cookies</h3>
                <p className="text-white/80 text-sm mb-2">These cookies are necessary for the website to function properly.</p>
                <ul className="text-white/70 text-sm space-y-1 list-disc list-inside">
                  <li>Authentication tokens</li>
                  <li>Session management</li>
                  <li>Security features</li>
                </ul>
              </div>

              <div className="border border-white/10 rounded-lg p-4">
                <h3 className="text-lg font-medium text-white mb-2">Functional Cookies</h3>
                <p className="text-white/80 text-sm mb-2">These cookies enable enhanced functionality and personalization.</p>
                <ul className="text-white/70 text-sm space-y-1 list-disc list-inside">
                  <li>User preferences</li>
                  <li>Language settings</li>
                  <li>Theme preferences</li>
                </ul>
              </div>

              <div className="border border-white/10 rounded-lg p-4">
                <h3 className="text-lg font-medium text-white mb-2">Analytics Cookies</h3>
                <p className="text-white/80 text-sm mb-2">These cookies help us understand how visitors interact with our platform.</p>
                <ul className="text-white/70 text-sm space-y-1 list-disc list-inside">
                  <li>Usage statistics</li>
                  <li>Performance monitoring</li>
                  <li>Error tracking</li>
                </ul>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Managing Cookies</h2>
            <p className="text-white/80 leading-relaxed mb-4">
              You can control and manage cookies in several ways:
            </p>
            <ul className="text-white/80 space-y-2 list-disc list-inside">
              <li><strong>Browser Settings:</strong> Most browsers allow you to refuse cookies or delete existing ones</li>
              <li><strong>Opt-out Tools:</strong> Use browser extensions or privacy tools</li>
              <li><strong>Platform Settings:</strong> Adjust cookie preferences in your account settings</li>
            </ul>
            
            <div className="bg-amber-500/10 border border-amber-500/20 rounded-lg p-4 mt-4">
              <p className="text-amber-200 text-sm">
                <strong>Note:</strong> Disabling essential cookies may affect the functionality of our platform.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Third-Party Cookies</h2>
            <p className="text-white/80 leading-relaxed mb-4">
              We may use third-party services that set their own cookies:
            </p>
            <ul className="text-white/80 space-y-2 list-disc list-inside">
              <li><strong>Supabase:</strong> Database and authentication services</li>
              <li><strong>Analytics providers:</strong> For usage statistics and improvements</li>
              <li><strong>Support tools:</strong> For customer service and help features</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Cookie Retention</h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-medium text-white mb-2">Session Cookies</h3>
                <p className="text-white/80">Deleted when you close your browser</p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-white mb-2">Persistent Cookies</h3>
                <p className="text-white/80">Stored for a predetermined period (typically 30 days to 2 years)</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Updates to This Policy</h2>
            <p className="text-white/80 leading-relaxed">
              We may update this Cookie Policy from time to time. We will notify you of any changes 
              by posting the new policy on this page with an updated revision date.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Contact Us</h2>
            <p className="text-white/80 leading-relaxed">
              If you have any questions about our use of cookies, please contact us at{' '}
              <a href="mailto:privacy@themikanaohub.com" className="text-crystal-orange hover:text-crystal-orange-glow transition-colors">
                privacy@themikanaohub.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;